import axios from "axios";
import moment from "moment";
import { DEFAULT_MOMENT_LOCALE } from "../../../i18n/helpers";
import { DateFormat } from "../../../modules/constants";

//Constants
const SET_DIET_DIARY_CHART_EXISTING_MEALS =
  "SET_DIET_DIARY_CHART_EXISTING_MEALS";
const SET_DIET_DIARY_HPBC_VALUES = "SET_DIET_DIARY_HPBC_VALUES";
const DIET_DIARY_CHARTS_RESET_STATE = "DIET_DIARY_CHARTS_RESET_STATE";
const SET_DAILY_TARGETS = "SET_DAILY_TARGETS";
const LOGOUT = "LOGOUT";

//Acessors
const getExistingDayMeals = (state) => state?.existingDayMeals;
const getHpbcVals = (state) => state?.hpbcVals;
const getDailyTargets = (state) => state?.dailyTargets;

//Default state
const initialState = {
  existingDayMeals: [],
  hpbcVals: [],
  dailyTargets: null,
};

export const dietDiaryChartsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DIET_DIARY_CHART_EXISTING_MEALS: {
      const { allMeals } = action;
      return Object.assign({}, state, {
        existingDayMeals: allMeals,
      });
    }
    case SET_DIET_DIARY_HPBC_VALUES: {
      const { hpbcVals } = action;
      return Object.assign({}, state, {
        hpbcVals: hpbcVals,
      });
    }
    case SET_DAILY_TARGETS: {
      const { dailyTargets } = action;
      return Object.assign({}, state, {
        dailyTargets: dailyTargets,
      });
    }
    case DIET_DIARY_CHARTS_RESET_STATE: {
      return initialState;
    }
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

//Mutators

export const resetStates = () => (dispatch) => {
  return dispatch({
    type: DIET_DIARY_CHARTS_RESET_STATE,
  });
};

export const setHpbcVals = (newValue) => (dispatch) => {
  return dispatch({
    type: SET_DIET_DIARY_HPBC_VALUES,
    hpbcVals: newValue,
  });
};

const fetchMealsByDate = (startDate, participantId) => (dispatch) => {
  const params = {
    StartDate: startDate,
    ParticipantId: participantId,
  };

  return axios
    .get(`/api/diet/dailyentries`, { params })
    .then(({ data }) => {
      dispatch({ type: SET_DAILY_TARGETS, dailyTargets: data?.dailyTargets });

      dispatch({
        type: SET_DIET_DIARY_CHART_EXISTING_MEALS,
        allMeals: formatDailyEntries(data.dailyEntries, startDate),
      });
    })
    .catch(() => {});
};

const formatDailyEntries = (dailyEntries, date) => {
  const dailyEntry =
    dailyEntries.length > 0
      ? dailyEntries[0]
      : {
          date: date,
          completed: false,
          fastingDay: false,
          meals: [],
        };

  const meals =
    dailyEntry.meals?.map((meal) => ({
      mealId: meal.mealId,
      aboutMeal: JSON.parse(meal?.mealJson ?? "").aboutMeal,
    })) ?? [];

  return meals;
};

export const mapStateToProps = (state) => {
  return {
    existingDayMeals: getExistingDayMeals(state),
    hpbcVals: getHpbcVals(state),
    dailyTargets: getDailyTargets(state),
  };
};

export const mapDispatchToProps = {
  fetchMealsByDate,
  setHpbcVals,
  resetStates,
};
